import { fetchAircraftError, fetchAircraftPending, fetchAircraftSuccess, focusAircraft, unFocusAircraft } from "../redux/actions";

const fetchAircraftData = (callsign, shouldGoTo) => {
    return async dispatch => {
        dispatch(fetchAircraftPending(callsign));
        try {
            let res = await fetch(`https://www.x-flightserver.org/yaam/get_webinfo.php?callsign=${callsign}`)
            //let res = await fetch(`//85.214.43.137:5000/data/${callsign}`)
            //let res = await fetch(`https://www.fsc-ev.de/yaam/get_webinfo.php?callsign=${callsign}`)
            //let res = await fetch(`http://127.0.0.1/yaam/get_webinfo.php?callsign=${callsign}`)
                        if (!res.ok) {
                throw Error(res.statusText);
            }

            res = await res.json();
            dispatch(fetchAircraftSuccess(res));
            dispatch(focusAircraft(shouldGoTo))
        } catch (error) {
            dispatch(fetchAircraftError(error));
            dispatch(unFocusAircraft())
        }
    }
}
export default fetchAircraftData;
